import { useState } from 'react';
import { IStore } from 'redux/create-style/create-style.slice';
import { StorePlatform } from '../type';
import { TaffiSubjects } from '../../../../types/subjects';
import { StockStatus } from '../../../cart/type';
import { useQuery } from '@apollo/client';
import { GET_STORE_PRODUCTS } from 'graph_ql/store/queries';
import { Currency } from '../../../user_reactions/types';

const useFetchStoreItems = (
    triggerFilter: boolean,
    setTriggerFilter: any,
    selectedStore: IStore,
    endCursor: string | null,
    query: string,
    listStyle: any[],
) => {
    const [storeItems, setStoreItems] = useState<any>(null);
    const [storeItemsLoading, setStoreItemsLoading] = useState(
        Boolean(
            triggerFilter &&
                selectedStore &&
                selectedStore.platform !== StorePlatform.Vogacloset &&
                !selectedStore.useTaffiItems,
        ),
    );
    const [pageInfo, setPageInfo] = useState<any>(null);
    const [lastQuery, setLastQuery] = useState('');

    useQuery(GET_STORE_PRODUCTS, {
        variables: {
            input: {
                storeId: selectedStore?.id,
                endCursor,
                queryString: query,
            },
        },
        skip: !triggerFilter || selectedStore === null || selectedStore.useTaffiItems,
        onCompleted: (response) => {
            console.log(response);
            const { products, pageInfo } = response.getStoreProducts;
            const resProducts = products.map((product) => {
                const {
                    id,
                    title,
                    description,
                    availableForSale,
                    onlineStoreUrl,
                    images,
                    options,
                    tags,
                    variants,
                    vendor,
                } = product;
                let price = 0,
                    currency = Currency.Sar;
                if (variants.length) {
                    price = +variants[0].price;
                    currency = variants[0].currency;
                }
                let colorsId = [],
                    sizesId = [],
                    tagsId = [],
                    brandId = {};
                if (options && options.length) {
                    for (const option of options) {
                        if (option.name === 'Size') {
                            sizesId = option.values.map((element) => {
                                return {
                                    subject: TaffiSubjects.TAFFI_SIZE,
                                    title: element,
                                    value: element,
                                };
                            });
                        }
                        if (option.name === 'Color') {
                            colorsId = option.values.map((element) => {
                                return {
                                    subject: TaffiSubjects.TAFFI_COLOR,
                                    title: element,
                                    value: element,
                                };
                            });
                        }
                    }
                }
                if (tags && tags.length) {
                    tagsId = tags.map((t) => {
                        return {
                            name: t,
                        };
                    });
                }
                if (typeof vendor === 'string' && vendor !== '') {
                    brandId = {
                        id: null,
                        name: vendor,
                    };
                }
                let productAffiliateUrl;
                if (onlineStoreUrl?.length) {
                    productAffiliateUrl = new URL(onlineStoreUrl);
                    new URL(selectedStore?.affiliateLink!).searchParams.forEach((key, val) => {
                        productAffiliateUrl.searchParams.append(val, key);
                    });
                }
                return {
                    storeId: selectedStore.id,
                    platform: StorePlatform.Shopify,
                    storeProductId: id,
                    url: onlineStoreUrl ? productAffiliateUrl?.href : '',
                    title,
                    description,
                    price,
                    currency,
                    images,
                    inStock: availableForSale ? StockStatus.True : StockStatus.False,
                    sizesId,
                    colorsId,
                    tagsId,
                    brandId,
                };
            });
            if (pageInfo.hasPreviousPage) {
                setStoreItems([...listStyle, ...resProducts]);
            } else {
                setStoreItems(resProducts);
            }
            setPageInfo(pageInfo);
            setLastQuery(query);
            setStoreItemsLoading(false);
            setTriggerFilter(false);
        },
        onError: (err) => {
            setPageInfo(null);
            setStoreItemsLoading(false);
            setTriggerFilter(false);
        },
    });

    return [storeItems, pageInfo, storeItemsLoading, lastQuery];
};

export default useFetchStoreItems;
